<ct-button
  style="margin: 0 8px"
  *ngIf="lead" [configuration]="submitButton"></ct-button>
